import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsT5 } from "../../../assets/imgs/Tema5";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	card: 4,
	monitorOne: 5,
	monitorTwo: 6,
	monitorThree: 7,
	monitorFour: 8,
	monitorFive: 9,
	monitorSix: 10,
	monitorSeven: 11,
	monitorEight: 12,
	monitorNine: 13,
	monitorTen: 14,
	monitorEleven: 16,
	monitorTwelve: 17,
	monitorThirteen: 18,
	monitorFourteen: 19,
	monitorFifteen: 20,
	monitorSixteen: 21,
	monitorSeventeen: 22,
	monitorEighTeen: 23,
	win: 24,
}

export const Tema5SubtopicFourActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema4], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema4 activity 1");
			ObserverEmitter.emit(EVENTS.tema5.subtopicFour.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicFour.initScene, 1);
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m1')
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Envío de OXXO a OXXO." />
					<DialogBarNew
						dialog={
							'¡Excelente! Es momento de tocar un tema que me emociona mucho. Hablaremos del envío de dinero de OXXO a OXXO.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4: Envío de OXXO a OXXO"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							'¡Observaremos los pasos a seguir para realizar esa transferencia.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a03)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							ObserverEmitter.emit(EVENTS.tema4.subtopicSix.activityOne.moveCamera)
							setUiToShow(steps.card);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.card && (
				<>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full pt-12 flex justify-center items-center">
						<div className="w-[224px] h-[280px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
							<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
								<p className="text-white text-[14px] md:text-[24px]">Solicita una identificación</p>
							</div>
							<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
								<div className="w-full h-full py-3">
									<img className="h-full w-full object-contain" src={imgsT5.question3} alt="Cliente con cajera OXXO" />
								</div>
							</div>
						</div>
					</div>
					<DialogBarNew
						dialog={
							"Paso uno: Solicita al Cliente su INE, es necesario para continuar con el proceso, en caso de no presentarla no se podrá continuar con la transferencia."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a04)
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m1')
							setUiToShow(steps.monitorOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorOne && (
				<>
					<DialogBarNew
						dialog={
							'Paso dos: Desde el Journal ingresa a la opción "Servicios“.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a05)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m2')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.13, 2.52)
							setUiToShow(steps.monitorTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTwo && (
				<>
					<DialogBarNew
						dialog={
							'Paso tres: Se muestra lista de servicios y seleccionamos “Envíos de dinero”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a06)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m3')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.13, 2.52)
							setUiToShow(steps.monitorThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorThree && (
				<>
					<DialogBarNew
						dialog={
							'Paso cuatro: Se muestra opciones de envío y retiro, elegimos “Envío de dinero”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a07)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m4')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.14, 2.79)
							setUiToShow(steps.monitorFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFour && (
				<>
					<DialogBarNew
						dialog={
							'Paso cinco: A continuación se muestra una lista de cajeros. Elegimos uno y damos en “Aceptar”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a08)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m5')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.06, 2.89)
							setUiToShow(steps.monitorFive);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFive && (
				<>
					<DialogBarNew
						dialog={
							'Paso seis: Capturamos contraseña del cajero.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a09)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m6')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.08, 2.65)
							setUiToShow(steps.monitorSix);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSix && (
				<>
					<DialogBarNew
						dialog={
							'Paso siete: Se muestra mensaje preguntando si se cuenta con los datos requeridos para el envío (INE, nombre de beneficiario, No. Telefónico).'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a10)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m7')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							setUiToShow(steps.monitorSeven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSeven && (
				<>
					<DialogBarNew
						dialog={
							'Paso ocho: Se muestra la opción indicando el monto máximo para envíos de dinero.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a11)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m8')
							setUiToShow(steps.monitorEight);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorEight && (
				<>
					<DialogBarNew
						dialog={
							'Paso nueve: Se requiere capturar y confirmar monto a enviar.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a12)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m9')
							setUiToShow(steps.monitorNine);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorNine && (
				<>
					<DialogBarNew
						dialog={
							'Paso diez: Se muestra información del envío para confirmar que los valores estén correctos.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a13)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m10')
							setUiToShow(steps.monitorTen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTen && (
				<>
					<DialogBarNew
						dialog={
							'Paso once: Se agrega al Journal el monto a enviar más la comisión.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a14)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m11')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.17, 2.84)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							setUiToShow(steps.monitorEleven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorEleven && (
				<>
					<DialogBarNew
						dialog={
							'Paso doce: Se totaliza la venta “$(+)”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a15)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m12')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.567, -0.22, 2.40)
							setUiToShow(steps.monitorTwelve);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTwelve && (
				<>
					<DialogBarNew
						dialog={
							'Paso trece: Seleccionamos una forma de pago.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a16)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m13')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							setUiToShow(steps.monitorThirteen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorThirteen && (
				<>
					<DialogBarNew
						dialog={
							'Paso catorce: Se muestra pantalla donde se solicita escanear el INE.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a17)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m14')
							setUiToShow(steps.monitorFourteen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFourteen && (
				<>
					<DialogBarNew
						dialog={
							'Paso quince: Se muestra la pantalla "Envíos de Dinero - Envíos" con la información del INE escaneado.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a18)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0, 2.75)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							setUiToShow(steps.monitorFifteen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFifteen && (
				<>
					<DialogBarNew
						dialog={
							'Paso dieciséis: El cajero ingresa datos complementarios.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a19)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.14, 2.95)
							setUiToShow(steps.monitorSixteen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSixteen && (
				<>
					<DialogBarNew
						dialog={
							'Paso diecisiete: Se elige al beneficiario y seleccionamos el botón de “Continuar”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a20)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.1, 2.81)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m15')
							setUiToShow(steps.monitorSeventeen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSeventeen && (
				<>
					<DialogBarNew
						dialog={
							'Paso dieciocho: Se muestra mensaje "¿Los datos del envío son correctos?“, el cajero valida la información, si todo es correcto, elegimos “si”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub04.sub4_act1_a21)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.1, 2.62)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's4_m16')
							setUiToShow(steps.monitorEighTeen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorEighTeen && (
				<>
					<DialogBarNew
						dialog={
							'Paso diecinueve: Se muestra mensaje de transacción exitosa, si el ticket se imprime correctamente elegimos la opción “si”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Hemos terminado con nuestro tema de Servicios Financieros. Nos veremos muy pronto para nuestro siguiente tema."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 10,
									subtema: tasksId.tema5.activities.subtema4,
								})
							);
							navigation("/home5/tema5/subtema4/results");
						}}
					/>
				</>
			)}

		</>

	)
}